import RelatoriosView from "@/views/relatorios/RelatoriosView";
import RelatPedidos from "@/components/relatorios/RelatPedidos";
import RelatVendas from "@/components/relatorios/RelatVendas";
import RelatFinanceiro from "@/components/relatorios/RelatFinanceiro";
import RelatPosicaoContratos from "@/components/relatorios/RelatPosicaoContratos";
import RelatClientesSemMovimento from "@/components/relatorios/RelatClientesSemMovimento";
import RelatDadosClientes from "@/components/relatorios/RelatDadosClientes";
import RelatResumoMediasVendedor from "@/components/relatorios/RelatResumoMediasVendedor";
import RelatVendasRealizadasInsVet from '@/components/relatorios/insumos-veterinaria/RelatVendasRealizadasInsVet.vue'
import RelatSaldoProntaEntrega from '@/components/relatorios/insumos-veterinaria/RelatSaldoProntaEntrega.vue'
import RelatPedidosInsVet from '@/components/relatorios/insumos-veterinaria/RelatPedidosInsVet.vue'

export default [
  {
    path: "/relatorios",
    name: "Nutrição Animal - Relatórios",
    component: RelatoriosView,
    meta: {
      requiresAuth: true,
      sync: true,
      online: true,
    },
  },
  {
    path: "/relatorios/pedidos",
    name: "Relatório - Pedidos realizados",
    component: RelatPedidos,
    meta: {
      requiresAuth: true,
      sync: true,
      online: true,
    },
  },
  {
    path: "/relatorios/vendas",
    name: "Relatório - Vendas Concretizadas",
    component: RelatVendas,
    meta: {
      requiresAuth: true,
      sync: true,
      online: true,
    },
  },
  {
    path: "/relatorios/financeiro",
    name: "Relatório - Financeiro",
    component: RelatFinanceiro,
    meta: {
      requiresAuth: true,
      sync: true,
      online: true,
    },
  },
  {
    path: "/relatorios/posicao-contratos",
    name: "Relatório - Posição de contratos",
    component: RelatPosicaoContratos,
    meta: {
      requiresAuth: true,
      sync: true,
      online: true,
    },
  },
  {
    path: "/relatorios/clientes-sem-movimentacao",
    name: "Relatório - Clientes sem movimentação",
    component: RelatClientesSemMovimento,
    meta: {
      requiresAuth: true,
      sync: true,
      online: true,
    },
  },
  {
    path: "/relatorios/dados-clientes",
    name: "Relatório - Dados Clientes",
    component: RelatDadosClientes,
    meta: {
      requiresAuth: true,
      sync: true,
      online: true,
    },
  },
  {
    path: "/relatorios/medias-vendedor",
    name: "Resumo Médias de Descontos/Comissões/Prazo de Vendas",
    component: RelatResumoMediasVendedor,
    meta: {
      requiresAuth: true,
      sync: true,
      online: true,
    },
  },
  {
    path: "/relatorios/veterinaria/vendas",
    name: "Relatório Vendas Realizadas Veterinária",
    component: RelatVendasRealizadasInsVet,
    meta: {
      requiresAuth: true,
      sync: true,
      online: true,
    },
  },
  {
    path: "/relatorios/veterinaria/pedidos",
    name: "Relatório Vendas Realizadas Veterinária",
    component: RelatPedidosInsVet,
    meta: {
      requiresAuth: true,
      sync: true,
      online: true,
    },
  },
  {
    path: "/relatorios/veterinaria/saldo-pronta-entrega",
    name: "Relatório Saldo Pronta Entrega",
    component: RelatSaldoProntaEntrega,
    meta: {
      requiresAuth: true,
      sync: true,
      online: true,
    },
  },
];
